<div class="search-container">
    <div class="header">
        <img class="asterik" src="../../assets/asterik.ico" alt="">
        <span class="header-text">ID Verification</span>
    </div>
</div>

<div *ngIf="showProgressBar">
    <mat-progress-bar mode="indeterminate">
    </mat-progress-bar>
</div>

<div class="contact-result-container" *ngIf="!showProgressBar">
    <div class="jurisdiction-container">
        <ng-container *ngIf="contacts.length === 0; else displayResult">
            <div class="jurisdiction-header-no-data">
                <img class="asterik" src="../../assets/asterisk-green.png" alt="">
                <span class="jurisdiction-text">No contacts available.</span>
            </div>
        </ng-container>
        <ng-template #displayResult>
            <div class="table-container">
                <table class="tbl contacts-table">
                    <thead>
                    <th width="10%">Contact Name</th>
                    <th width="6%">Type</th>
                    <th width="8%">Phone</th>
                    <th width="8%" *ngIf="hasIndividual()">
                        Date of Birth
                    </th>

                    <th width="11%">Email</th>
                    <th width="15%">Address</th>
                    <th width="6%">Other IDs</th>
                    <th width="4%">Include</th>
                    <th width="4%">Primary Contact</th>
                    <th width="6%">Biometrics</th>
                    <th width="10%">Role</th>
                    <th width="11%">ID Documents</th>
                    <th width="11%">Proof of Address</th>
                    <th width="15%">Field Requirements</th>
                    </thead>
                    <tbody>
                        <tr *ngFor="let data of contacts; trackBy: trackByContactId">
                            <td>{{data.contactId}} : {{data.contactName}}</td>
                            <td>{{data.isCompany? 'Company':'Individual'}}</td>
                            <td>
                                <span *ngIf="data.mobilePhoneNumber"><b>Mobile: </b>{{data.mobilePhoneNumber}}</span>
                                <span *ngIf="data.phone"><br /><b *ngIf="data.phoneType">{{data.phoneType}}: </b>{{data.phone}}</span>
                            </td>
                            <td *ngIf="hasIndividual()">
                                <span *ngIf="!data.isCompany; else notApplicable">
                                    {{ data.dateOfBirth }}
                                </span>

                                <ng-template #notApplicable>
                                    Not Applicable
                                </ng-template>
                            </td>

                            <td>{{data.email}}</td>
                            <td>{{createAddress(data)}}</td>
                            <td>
                                <span *ngIf="data.isCompany && data.businessRegNumber">
                                    <b>Company Registration Number:</b> {{data.businessRegNumber}}
                                </span>
                                <span *ngIf="!data.isCompany && data.taxNumber">
                                    <b>NI Number:</b> {{data.taxNumber}}
                                </span>
                            </td>
                            <td>
                                <mat-checkbox (click)="include(data.contactId)" [checked]="isIncluded(data.contactId)" [required]="isIncluded(data.contactId)" title="Verify this contact"></mat-checkbox>
                            </td>
                            <td>
                                <mat-checkbox [checked]="data.isPrimary" (click)="changeIsPrimary(data.contactId)" [disabled]="disableCheckbox(data.contactId)" [required]="isIncluded(data.contactId)" title="Make this the primary contact"></mat-checkbox>
                            </td>
                            <td>
                                <mat-checkbox (click)="checkBiometric(data)" [checked]="data.IsBiometric" title="Run biometric identification checks"></mat-checkbox>
                            </td>
                            <td>
                                <mat-form-field class="role-select" style="width:100%">
                                    <mat-label *ngIf="!data.role">Select a role</mat-label>
                                    <mat-select [disabled]="data.isCompany" [(value)]="data.role" [required]="!data.isCompany && isIncluded(data.contactId)">
                                        <mat-option value="APPLICANT">Applicant</mat-option>
                                        <mat-option value="DIRECTOR">Director</mat-option>
                                        <mat-option value="SHAREHOLDER">Shareholder</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </td>
                            <td>
                                <button class="btn-select" (click)="onButtonClick(data.contactId, 1)">Add Document</button>
                                <ng-container *ngIf="data.selectedDocuments">
                                    <div class="selected-docs">
                                        <ul>
                                            <li *ngFor="let doc of getdocumentsbytype(data.selectedDocuments, 'POI'); let i = index"
                                                [class.border-bottom]="data.selectedDocuments.length > 1 && i < data.selectedDocuments.length - 1"
                                                class="list-item-doctype">
                                                <div> {{ doc.name }}{{ doc.extension }} </div>
                                                <button class="remove-doc-btn"
                                                        title="Remove Document"
                                                        (click)="removeDocument(data.contactId, doc)">
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </li>
                                        </ul>

                                    </div>

                                </ng-container>
                            </td>
                            <td>
                                <button class="btn-select" (click)="onButtonClick(data.contactId, 2)">Add Document</button>
                                <ng-container *ngIf="data.selectedDocuments">
                                    <div class="selected-docs">
                                        <ul>
                                            <li *ngFor="let doc of getdocumentsbytype(data.selectedDocuments, 'POA'); let i = index"
                                                [class.border-bottom]="data.selectedDocuments.length > 1 && i < data.selectedDocuments.length - 1"
                                                class="list-item-doctype">
                                                <div>{{ doc.name }}{{ doc.extension }}</div>
                                                <button class="remove-doc-btn"
                                                        title="Remove Document"
                                                        (click)="removeDocument(data.contactId, doc)">
                                                    <mat-icon>cancel</mat-icon>
                                                </button>
                                            </li>
                                        </ul>

                                    </div>
                                </ng-container>
                            </td>
                            <td>
                                <xp-country-field-requirements [contact]="data" [config]="configFor(data)" [citizenshipCodes]="citizenshipCodes"></xp-country-field-requirements>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ng-template>
    </div>
</div>
<div *ngIf="!showProgressBar && contacts.length > 0" class="contact-result-footer">
    <button mat-raised-button [disabled]="!verifybtn()" class="btn-verify" [ngClass]="{'disabled-button': verifybtn(), 'enabled-button': !verifybtn()}" (click)="idVerify()">Verify</button>
</div>
